/**
 * Kendali zoom sebuah peta: perbesar, perkecil, dan kembali pas.
 *
 * Roda tetikus sudah cukup bagi yang tahu ia ada, dan itulah masalahnya —
 * tak ada apa pun di layar yang memberi tahu bahwa peta ini bisa diperbesar.
 * Tiga tombol kecil di sudut mengatakannya, dan sekaligus melayani tetikus
 * tanpa roda serta layar sentuh.
 *
 * Angka perbesaran hanya muncul setelah pengguna beranjak dari pandangan pas:
 * "1,0×" yang menetap di sudut peta yang belum disentuh siapa pun adalah
 * hiasan, bukan keterangan.
 */

const BUTTON: React.CSSProperties = {
  width: 22,
  height: 20,
  display: "grid",
  placeItems: "center",
  background: "var(--control)",
  border: "1px solid var(--border-control)",
  borderRadius: 4,
  color: "var(--ink-2)",
  font: "600 12px var(--font-mono)",
  cursor: "pointer",
  padding: 0,
};

export default function MapZoomControls({
  zoom,
  home,
  onIn,
  onOut,
  onReset,
  corner = "top-left",
}: {
  zoom: number;
  /** Benar bila peta masih pada pandangan pas; tombol pulang lalu diredupkan. */
  home: boolean;
  onIn: () => void;
  onOut: () => void;
  onReset: () => void;
  corner?: "top-left" | "top-right" | "bottom-right" | "under-compass";
}) {
  // "under-compass" duduk di bawah panah utara pada peta lapangan; sudut kanan
  // bawahnya sudah ditempati pembacaan koordinat.
  const place =
    corner === "top-left"
      ? { left: 7, top: 7 }
      // Sudut kiri atas peta horizon model geologi sekarang milik angka
      // northing paling utara, dan tombol yang duduk di atasnya menutupi
      // justru angka yang paling sering dibaca orang di peta itu.
      : corner === "top-right"
        ? { right: 7, top: 7 }
        : corner === "under-compass"
          ? { right: 14, top: 64 }
          : { right: 7, bottom: 7 };
  return (
    <div
      style={{
        position: "absolute",
        ...place,
        display: "flex",
        flexDirection: "column",
        gap: 3,
        alignItems: "center",
        zIndex: 2,
      }}
    >
      <button type="button" style={BUTTON} onClick={onIn} title="Zoom in (mouse wheel)">
        +
      </button>
      <button type="button" style={BUTTON} onClick={onOut} title="Zoom out (mouse wheel)">
        −
      </button>
      <button
        type="button"
        style={{ ...BUTTON, color: home ? "var(--ink-6)" : "var(--accent)" }}
        onClick={onReset}
        disabled={home}
        title="Back to one screen"
      >
        ⌂
      </button>
      {!home && (
        <span
          style={{
            font: "500 8px var(--font-mono)",
            color: "var(--ink-4)",
            background: "var(--panel)",
            border: "1px solid var(--line)",
            borderRadius: 3,
            padding: "1px 3px",
          }}
        >
          {zoom.toFixed(zoom < 10 ? 1 : 0)}×
        </span>
      )}
    </div>
  );
}
